<footer class="bg-white border-t">
	<div class="max-w-screen-xl mx-auto flex flex-col items-center gap-2 sm:gap-4 py-2 sm:py-4">
		<!-- Primera línea de logos -->
		<div class="flex justify-center items-center gap-0 md:gap-1 lg:gap-2 xl:gap-4">
			<img
				src="assets/logos/UE.png"
				alt="Unión Europea"
				class="h-[25px] md:h-[45px] lg:h-[60px] xl:h-[80px] w-auto object-contain"
			/>
			<img
				src="assets/logos/gobierno.png"
				alt="Gobierno de España"
				class="h-[25px] md:h-[45px] lg:h-[60px] xl:h-[80px] w-auto object-contain"
			/>
			<img
				src="assets/logos/logo_dos_lineas.png"
				alt="Plan de Recuperación, Transformación y Resiliencia"
				class="h-[35px] md:h-[60px] lg:h-[90px] xl:h-[120px] w-auto"
			/>
			<img
				src="assets/logos/bandera.png"
				alt="Bandera de España"
				class="h-[25px] md:h-[45px] lg:h-[60px] xl:h-[80px] w-auto object-contain"
			/>
		</div>

		<!-- Segunda línea de logos -->
		<div class="flex justify-center items-center gap-2 sm:gap-4 flex-wrap">
			<img
				src="assets/logos/telefonica.png"
				alt="Telefónica"
				class="h-[50px] sm:h-[80px] w-auto object-contain"
			/>
			<img
				src="assets/logos/112.png"
				alt="112 Emergencias"
				class="h-[50px] sm:h-[80px] w-auto object-contain"
			/>
			<img src="assets/logos/gamma.png" alt="Gamma" class="h-[50px] sm:h-[80px] w-auto object-contain" />
		</div>
	</div>
</footer>
